import React from 'react';
import { Route } from 'react-router-dom';
import { ApolloWrapper } from 'utils/ApolloWrapper';

export const PageRoute = ({
  PageComponent,
  graphqlUrl,
  ...otherProps
}: any) => {
  const baseRoute = otherProps.computedMatch.url;
  const baseWrapper = (props: any) => (
    <ApolloWrapper graphqlUrl={graphqlUrl}>
      <PageComponent baseRoute={baseRoute} {...props} />
    </ApolloWrapper>
  );

  return <Route {...otherProps} render={baseWrapper} />;
};
